import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import Registry from '../../../registry/index';

class SentryErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({eventId});
    });
  }

  render() {
    const lang = Registry.get('locale');
    if (this.state.hasError) {
      //render fallback UI
      return (
        <div className="error-boundary">
          {lang.error}
          <button
            className="feedback-button"
            onClick={() => Sentry.showReportDialog({
              eventId: this.state.eventId,
              successMessage: lang.submit_success,
              title: lang.error,
              lang: lang._code,
            })}>
              {lang.submit_error}
          </button>
          <span className="reload">{lang.just_reload}
            <span className="link" onClick={() => document.location.reload(true)}>
              {lang.reload_link}
            </span>
          </span>
        </div>
      );
    }

    //when there's not an error, render children untouched
    return this.props.children;
  }
}

export default SentryErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SentryErrorBoundary/index.js